import React from "react";
import { Container, Grid2 as Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

interface FooterProps {
  onLoginClick: () => void;
}

const Footer: React.FC<FooterProps> = ({onLoginClick} : FooterProps) => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <div className="w-full text-white midnightBlueBackground">
      <Container style={{maxWidth: "unset", margin: "0", width: "100%"}} className="py-0">
        <Grid container spacing={2}>
          <Grid size={isMobile ? 12 : 9}>
            <p className="text-sm leading-relaxed opacity-90 max-w-none">
              Copyright 2018-{currentYear} Amtrak Police Department. The 
              information/training contained on this website is supported by 
              the Department of Homeland Security (DHS) under the Intercity 
              Passenger Rail grant. The content is solely the responsibility 
              of Amtrak and does not necessarily represent the official view of DHS.
            </p>
          </Grid>
          {isMobile ? 
            <Grid size={12} style={{transform: "translateY(-20px)", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <img
                style={{width: "200px"}}
                src="/images/AmtrakLogo.png"
                alt="AMTRAK"
                className="h-14 object-contain"
              />
            </Grid>
            : 
            <Grid size={2} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
              <img
                  style={{width: "200px"}}
                  src="/images/AmtrakLogo.png"
                  alt="AMTRAK"
                  className="h-14 object-contain"
                />
            </Grid>
          }
          
        </Grid>
      </Container>
    </div>
  );
};

export default Footer;
